module.exports = __webpack_public_path__ + "img/logo.6af338f6.png";